/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
  GetApiV1PersonPersonidResumeeEnrollmentsPathParams,
  GetApiV1PersonPersonidResumeeEnrollments400,
  GetApiV1PersonPersonidResumeeEnrollments401,
  GetApiV1PersonPersonidResumeeEnrollments500,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeEnrollments.ts";

function getGetApiV1PersonPersonidResumeeEnrollmentsUrl(
  personId: GetApiV1PersonPersonidResumeeEnrollmentsPathParams["personId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${personId}/resumee/enrollments` as const,
  };
  return res;
}

/**
 * @description Retorna os dados em comum e a lista de matrículas da pessoa **(Requer Authorization para autenticação)**
 * @summary Retorna aba de Matrículas do currículo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:personId/resumee/enrollments}
 */
export async function getApiV1PersonPersonidResumeeEnrollments(
  personId: GetApiV1PersonPersonidResumeeEnrollmentsPathParams["personId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeEnrollments400
      | GetApiV1PersonPersonidResumeeEnrollments401
      | GetApiV1PersonPersonidResumeeEnrollments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonPersonidResumeeEnrollmentsUrl(
      personId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
